/*
  product-card-v2.js — mobile swipe dots for snippets/product-card-v2.liquid.
  The gallery itself is pure CSS (scroll-snap); this only keeps the active dot in
  sync with the scroll position. Cards appended later (infinite scroll of
  <main-collection-grid>) are picked up through a MutationObserver on the grid.
*/
(function () {
  'use strict';

  function bind(gallery) {
    if (gallery.__pc2) return;
    gallery.__pc2 = true;
    var card = gallery.closest('.pc2');
    var dots = card && card.querySelector('[data-pc2-dots]');
    if (!dots) return;
    var items = dots.children;
    var ticking = false;

    gallery.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          ticking = false;
          var width = gallery.clientWidth || 1;
          var index = Math.round(gallery.scrollLeft / width);
          for (var i = 0; i < items.length; i++) {
            items[i].classList.toggle('is-active', i === index);
          }
        });
      },
      { passive: true }
    );
  }

  function init(root) {
    var galleries = (root || document).querySelectorAll('[data-pc2-gallery]');
    for (var i = 0; i < galleries.length; i++) bind(galleries[i]);
  }

  function start() {
    init(document);
    var grid = document.getElementById('collection__main-grid');
    if (grid && 'MutationObserver' in window) {
      new MutationObserver(function () {
        init(grid);
      }).observe(grid, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
